import { createSelector } from 'reselect';
import { FACETS_KEY } from './constants';
import searchSelector from '../searchSelector';

export const getCheckedOptionsMap = createSelector(
    searchSelector,
    search => search[FACETS_KEY],
);
